import { Dayjs } from 'dayjs';

// FullCalendar treats `end` as exclusive for all-day events: a stay from the 12th to the 16th
// must have end = 17th 00:00 to render the 16th. If we forward the raw endTime (e.g. 16th 11:00),
// FC rounds it down and the departure day disappears from the ribbon.
//
// Examples:
//   endTime = 2026-09-16T11:00 → returns 2026-09-17T00:00 (departure day included)
//   endTime = 2026-09-16T00:00 → returns 2026-09-16T00:00 (already at day boundary)
const toFullCalendarAllDayEnd = (endTime: Dayjs): Date => {
  const dayStart = endTime.startOf('day');
  return endTime.isSame(dayStart) ? dayStart.toDate() : dayStart.add(1, 'day').toDate();
};

export default toFullCalendarAllDayEnd;
